import React, {Component} from 'react'
import ProjectInvoiceList from "./ProjectInvoiceList"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button} from 'reactstrap'
import {Mutation} from 'react-apollo'

import {
    checkPermission,
    PROJECTS_CAN_DOWNLOAD_INVOICES,
    PROJECTS_CAN_REMOVE_INVOICES,
    PROJECTS_CAN_CREATE_INVOICES,
    PROJECTS_CAN_EDIT_INVOICES
} from "../../lib/permissions"
import ProjectInvoiceInput from "./project/ProjectInvoiceInput"
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import {toast} from "react-toastify";
import ProjectInvoiceModal from "./reports/ProjectInvoiceModal";
import CreditNoteModal from './reports/ProjectInvoiceCreditNoteModal'


export default class ProjectInvoices extends Component {

    state = {
        showInput: false,
        showEdit: false,
        showCreditNoteModal: false,
        creditNoteInvoiceID: null,
        invoiceID: null
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleEdit = () => {
        this.setState({showEdit: !this.state.showEdit})
    }

    toggleCreditNoteModal = (invoiceID) => {
        this.setState({showCreditNoteModal: !this.state.showCreditNoteModal, creditNoteInvoiceID: invoiceID})
    }

    render() {

        const {toggle} = this
        const {project_id, invoices, project, refetch} = this.props
        const {showInput} = this.state

        console.log('props', this.props)

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <div>
                        <Button
                            size="sm"
                            color={showInput ? 'warning' : 'success'}
                            disabled={!checkPermission(PROJECTS_CAN_CREATE_INVOICES)}
                            onClick={this.toggle}
                        >
                            <FontAwesomeIcon color="#fff" icon={showInput ? 'minus' : 'plus'}/>{' '}
                            {showInput ? 'Cancel' : 'Add Invoice'}
                        </Button>
                        <ProjectInvoiceList
                            canDownload={checkPermission(PROJECTS_CAN_DOWNLOAD_INVOICES)}
                            canRemove={checkPermission(PROJECTS_CAN_REMOVE_INVOICES)}
                            canEdit={checkPermission(PROJECTS_CAN_EDIT_INVOICES)}
                            project_id={project_id}
                            invoices={invoices}
                            onEdit={(invoiceID) => {
                                this.setState({invoiceID})
                                this.toggleEdit()
                            }}
                            onAddCreditNote={(invoiceID) => {
                                this.toggleCreditNoteModal(invoiceID)
                            }}
                        />


                        <ProjectInvoiceInput
                            toggle={toggle}
                            onSave={(data) => {
                                console.log('save', data)
                                editProjectLocalMutationFunc({variables: {data}})
                                toast.success('Invoice Created', {autoClose: 2000})
                                this.toggle()
                            }}
                            project_id={project_id}
                            isOpen={showInput}
                        />


                        <ProjectInvoiceModal
                            isOpen={this.state.showEdit}
                            toggle={this.toggleEdit}
                            onSave={(data) => {
                                editProjectLocalMutationFunc({variables: {data}})
                                this.toggleEdit()
                            }}
                            invoiceID={this.state.invoiceID}
                        />

                        <CreditNoteModal
                            isOpen={this.state.showCreditNoteModal}
                            toggle={this.toggleCreditNoteModal}
                            invoice_id={this.state.creditNoteInvoiceID}
                            onSave={() => {
                                refetch()
                                this.setState({showCreditNoteModal: false, creditNoteInvoiceID: null})
                            }}
                        />
                    </div>
                )}

            </Mutation>

        )
    }

}